export default "__VITE_ASSET__4046b921__"